import React from 'react'
import createContext from 'zustand/context'
import shallow from 'zustand/shallow'

const { Provider, useStore } = createContext()
const CustomStoreProvider = function ({ children, createStore }) {
  if (!createStore) {
    return children
  }
  return <Provider createStore={createStore}>{children}</Provider>
}

const useCustomStore = (selectors, equalityFn = shallow) =>
  useStore(selectors, equalityFn)

export { CustomStoreProvider, useCustomStore }
